import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCircleRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import PickAndMixListCard from 'Components/PickAndMix/Cards/PickAndMixListCard';
import PickAndMixCard from 'Components/PickAndMix/Cards/PickAndMixCard';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import { currencyCode } from 'Helpers/Geo/data';
import { messages } from 'Components/PickAndMix/PickAndMixHelper';
import { addAll } from 'Redux/ducks/cart';
import useViewport from 'Hooks/useViewport';

import 'Components/PickAndMix/PickAndMixPreselectedSegment.scss';

const PickAndMixPreselectedSegment = ({ preselection, addAll: adAllProp }) => {
  const { formatMessage } = useIntl();
  const { isAboveSm } = useViewport();


  if (!preselection) return null;

  const {
    title, desc, hits, percentSaved, price, fullPrice, preselectedLink, categoryName, type,
  } = preselection;

  if (hits && hits.length === 0) return null;

  const handleAddAll = () => {
    const productIds = hits.map(hit => hit._id);
    adAllProp(productIds);
  };


  return (
    <div className="PickAndMixPreselectedSegment">
      <div className="PickAndMixPreselectedSegment__titleAction">
        <div className="PickAndMixPreselectedSegment__titleWrapper">
          <h3 className="PickAndMixPreselectedSegment__title">{formatMessage(title, { categoryName })}</h3>
        </div>

        <div className="PickAndMixPreselectedSegment__priceButtonContainer">
          <div className="PickAndMixPreselectedSegment__price">
            <div className="PickAndMixPreselectedSegment__price__discount">
              -<SpecialFormattedNumber value={percentSaved} style="percent" />
            </div>

            <div className="PickAndMixPreselectedSegment__price__wasPricePrice">
              <div className="PickAndMixPreselectedSegment__price__wasPrice">
                <SpecialFormattedNumber
                  value={fullPrice}
                  style="currency"
                  currency={currencyCode}
                />
              </div>
              <div className="PickAndMixPreselectedSegment__price__price">
                <SpecialFormattedNumber
                  value={price}
                  style="currency"
                  currency={currencyCode}
                />
              </div>
            </div>
          </div>
          {isAboveSm &&
            <div className="PickAndMixPreselectedSegment__buttons">
              <Link
                to={`/pick-and-mix/${preselectedLink}`}
                target="_blank"
                rel="noopener noreferrer"
                className="PickAndMixPreselectedSegment__buttons__viewBundle btn"
                aria-label={formatMessage(messages.viewBundle)}
              >
                <FontAwesomeIcon icon={faCircleRight} />
                <FormattedMessage id="pickandmixpreselectedproduct.view" defaultMessage="View" />

              </Link>
              <button
                className="PickAndMixPreselectedSegment__buttons__addAll btn btn-primary"
                aria-label={formatMessage(messages.remove)}
                onClick={handleAddAll}
              >
                <FontAwesomeIcon icon={faPlus} />
                <FormattedMessage id="pickandmixpreselectedproduct.addall" defaultMessage="Add all" />

              </button>
            </div>
          }

        </div>
      </div>

      {!isAboveSm &&
        <div className="PickAndMixPreselectedSegment__buttons">
          <Link
            to={`/pick-and-mix/${preselectedLink}`}
            target="_blank"
            rel="noopener noreferrer"
            className="PickAndMixPreselectedSegment__buttons__viewBundle btn"
            aria-label={formatMessage(messages.viewBundle)}
          >
            <FontAwesomeIcon icon={faCircleRight} />
            <FormattedMessage id="pickandmixpreselectedproduct.view" defaultMessage="View" />

          </Link>
          <button
            className="PickAndMixPreselectedSegment__buttons__addAll btn btn-primary"
            aria-label={formatMessage(messages.remove)}
            onClick={handleAddAll}
          >
            <FontAwesomeIcon icon={faPlus} />
            <FormattedMessage id="pickandmixpreselectedproduct.addall" defaultMessage="Add all" />

          </button>
        </div>
      }

      <div className="PickAndMixPreselectedSegment__desc">
        {formatMessage(desc, { categoryName })}
      </div>

      {isAboveSm &&
        <div className="PickAndMixPreselectedSegment__hits">
          {hits.map(hit =>
            <PickAndMixListCard key={hit._id} hit={hit} preSelectedType={type} />,
          )}
        </div>
      }


      {!isAboveSm &&
        <div className="fan-grid-container PickAndMixPreselectedSegment__mobileHits">
          {hits.map((hit, i) =>
            <div className="two-column-row" key={hit._id}>
              <PickAndMixCard
                isPartOfPreselected
                preSelectedType={type}
                cardIndex={i}
                key={hit._id}
                hit={hit}
                switchCarouselGame={() => { }}
              />
            </div>,
          )}
        </div>

      }

    </div>
  );
};

PickAndMixPreselectedSegment.propTypes = {
  preselection: PropTypes.shape({
    hits: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.object,
    desc: PropTypes.object,
    type: PropTypes.string,
  }),
};

PickAndMixPreselectedSegment.defaultProps = {
  preselection: null,
};

export default connect(null, { addAll })(PickAndMixPreselectedSegment);

